/**
 * Client for `POST /pwa/api/ask` — the peck answer call. The backend runs the
 * routed completion in-process, metered to the signed-in account; the browser
 * builds the whole prompt and never sees an API key.
 */
import { api } from './api';

export interface AskMessage {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

export interface AskRequest {
  messages: AskMessage[];
  max_tokens?: number;
  response_format?: { type: 'text' | 'json_object' };
  /** `phase:slot`; defaults to `peck:answer` server-side. */
  workload?: string;
}

export interface AskResult {
  answer: string;
  callId: string | null;
  model: string | null;
  usage: { prompt_tokens: number; completion_tokens: number; total_tokens: number } | null;
}

export function askNest(body: AskRequest): Promise<AskResult> {
  return api.post<AskResult>('/pwa/api/ask', body as unknown as Record<string, unknown>);
}
